import { SkillForm } from "@/core/skillForms/types";
import { settlementOfferSkillStep1 } from "./step1";
import { settlementOfferSkillStep2 } from "./step2";

export const settlementOfferSkillForm: SkillForm = {
  skillId: "settlement_offer",
  title: "Elaborar proposta de acordo",
  steps: [settlementOfferSkillStep1, settlementOfferSkillStep2],
};
